export default __webpack_public_path__ + "static/ask-question-27ede2670350eae9436b69de47b63f59.svg";